// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Or7W","field":"styles_field__G8xlH","fieldCol":"styles_fieldCol__13EkH","diffCol":"styles_diffCol__1KgwK","diff":"styles_diff___KHdQ"};